// Text is { th, en }; render it with t() from ./lang.

export const company = {
  name: { th: "บจก.จีดับบลิวเอส รีเสิร์ช แอนด์ ดีเวลลอปเม้นท์", en: "GWS Research & Development Co., Ltd." },
  address: {
    th: "1233/66 ซอยแพรกษา 8 ตำบลแพรกษา อำเภอเมืองสมุทรปราการ จังหวัดสมุทรปราการ 10280",
    en: "1233/66 Soi Phraeksa 8, Phraeksa, Mueang Samut Prakan, Samut Prakan 10280",
  },
  phone: "080 074 1888",
  tel: "+66800741888",
  email: "sales_admin@gws-rd.com",
  facebook: "https://www.facebook.com/1665740753644385",
  map: "https://www.google.com/maps?q=13.5659517,100.6390671&z=16&output=embed",
  mapLink: "https://www.google.com/maps/search/?api=1&query=13.5659517,100.6390671",
};

export const groups = [
  { id: "handling", name: { th: "ลำเลียงและขนถ่าย", en: "Conveying & handling" } },
  { id: "robotics", name: { th: "หุ่นยนต์และ AGV", en: "Robotics & AGV" } },
  { id: "control", name: { th: "ชั่งน้ำหนัก ควบคุม และมาร์กกิ้ง", en: "Weighing, control & marking" } },
];

// sample: true = illustrative photo, not GWS's own build (credit in `credits`).
export const products = [
  {
    id: "conveyor",
    group: "handling",
    name: { th: "สายพานลำเลียงสั่งทำ", en: "Custom conveyors" },
    des: {
      th: "สายพาน PU, modular และ wire-mesh โครงสแตนเลสสำหรับไลน์อาหาร ออกแบบตามขนาดชิ้นงานและจังหวะการผลิต ลดการใช้แรงงานคน",
      en: "PU, modular and wire-mesh belts on stainless frames for food lines, sized to your product and line rate, cutting manual handling.",
    },
    img: "/images/mesh-conveyor.webp",
  },
  {
    id: "cleated",
    group: "handling",
    name: { th: "สายพานยกขึ้น (Cleated / Incline)", en: "Cleated incline conveyors" },
    des: {
      th: "ยกวัตถุดิบหรือชิ้นงานขึ้นเครื่องจักรหรือเครื่องแพ็ค ล้างทำความสะอาดง่าย เหมาะกับห้องผลิตอาหาร",
      en: "Lift ingredients or pieces up into machines and packers. Easy to wash down for food production rooms.",
    },
    img: "/images/cleated-conveyor.webp",
  },
  {
    id: "vibrating",
    group: "handling",
    name: { th: "สายพานสั่น / Vibratory feeder", en: "Vibratory conveyors & feeders" },
    des: {
      th: "สำหรับวัตถุดิบแบบผง เมล็ด และเกล็ด เช่น ครีมเทียม นมผง แป้ง เกล็ดขนมปัง ผงปรุงรส ป้อนสม่ำเสมอ",
      en: "For powders, grains and flakes such as creamer, milk powder, flour, breadcrumbs and seasoning, fed at an even rate.",
    },
    img: "/images/vibratory-feeder.webp",
    sample: true,
  },
  {
    id: "packing",
    group: "handling",
    name: { th: "สายพานเรียงจังหวะเข้าเครื่องแพ็ค", en: "Infeed & timing to packers" },
    des: {
      th: "เรียงขนมหรือชิ้นงานให้ได้ระยะและจังหวะตรงกับเครื่องแพ็ค นับ แยก และรวมไลน์ด้วยบาร์โค้ด",
      en: "Space and time snacks or pieces to match the packer, then count, sort and merge lines by barcode.",
    },
    img: "/images/packaging-line.webp",
    sample: true,
  },
  {
    id: "agv",
    group: "robotics",
    name: { th: "AGV หุ่นยนต์ขนส่งอัตโนมัติ", en: "AGV (Automated Guided Vehicle)" },
    des: {
      th: "ขนส่งสินค้าและวัตถุดิบระหว่างสถานีโดยไม่ต้องมีคนขับ ปรับแบบตามหน้างาน",
      en: "Moves goods and materials between stations without a driver, built to fit your floor.",
    },
    img: "/images/agv.webp",
    sample: true,
  },
  {
    id: "palletizer",
    group: "robotics",
    name: { th: "หุ่นยนต์จัดเรียงพาเลท (Palletizer)", en: "Robotic palletizers" },
    des: {
      th: "จัดเรียงกล่องหรือตะกร้าขึ้นพาเลทอัตโนมัติ รวดเร็วและแม่นยำ ใช้หุ่นยนต์ ABB ในฐานะตัวแทนจำหน่าย",
      en: "Stacks cases or crates onto pallets quickly and precisely, using ABB robots as an authorised dealer.",
    },
    img: "/images/palletizer.webp",
    sample: true,
  },
  {
    id: "weighing",
    group: "control",
    name: { th: "ระบบชั่งน้ำหนัก Load cell / Weight module", en: "Load cells & weigh modules" },
    des: {
      th: "ชั่งถัง ไซโล กรวยจ่าย และสายพาน ใช้ Load cell, Weight module และ ACT350 ของ Mettler Toledo",
      en: "Weigh tanks, silos, hoppers and conveyors with load cells, weigh modules and the Mettler Toledo ACT350.",
    },
    img: "/images/load-cell.webp",
    sample: true,
  },
  {
    id: "cabinet",
    group: "control",
    name: { th: "ตู้คอนโทรลและระบบไฟฟ้า", en: "Control cabinets & electrical" },
    des: {
      th: "ตู้คอนโทรลสแตนเลส PLC รางไฟ และงานเดินสายในโรงงาน ประกอบและทดสอบเองทั้งหมด",
      en: "Stainless control cabinets, PLCs, cable trays and plant wiring, all built and tested in-house.",
    },
    img: "/images/control-cabinet.webp",
  },
  {
    id: "scada",
    group: "control",
    name: { th: "SCADA และการเก็บข้อมูลการผลิต", en: "SCADA & production data" },
    des: {
      th: "ดูสถานะไลน์ เก็บและวิเคราะห์ข้อมูลแบบเรียลไทม์ และควบคุมการผลิตจากระยะไกล",
      en: "Watch line status, log and analyse data in real time, and control production remotely.",
    },
    img: "/images/scada.webp",
    sample: true,
  },
  {
    id: "laser",
    group: "control",
    name: { th: "Laser marker และเครื่องคัดแยกด้วยบาร์โค้ด", en: "Laser marking & barcode sorting" },
    des: {
      th: "มาร์กโค้ด วันผลิต และโลโก้ลงบนชิ้นงานโดยตรง และสแกนบาร์โค้ดเพื่อคัดแยกสินค้า",
      en: "Mark codes, dates and logos straight onto products, and scan barcodes to sort them.",
    },
    img: "/images/laser-marker.webp",
    sample: true,
  },
];

// What the visitor makes -> the systems GWS would put on that line.
export const lines = [
  { id: "powder", name: { th: "ผง เมล็ด เกล็ด", en: "Powder, grain, flakes" }, picks: ["vibrating", "weighing", "cleated"] },
  { id: "snack", name: { th: "ขนม เบเกอรี่", en: "Snacks & bakery" }, picks: ["conveyor", "packing", "laser"] },
  { id: "bottle", name: { th: "ของเหลว บรรจุขวด", en: "Liquids & bottling" }, picks: ["weighing", "conveyor", "scada"] },
  { id: "case", name: { th: "กล่อง ลัง ปลายไลน์", en: "Cases & end of line" }, picks: ["palletizer", "agv", "laser"] },
];

export const projects = [
  { food: true, year: 2020, client: "AB Food & Beverages", name: { th: "เครื่อง CVC ยกกล่องขึ้นสายพานหลัก", en: "CVC case lift onto the main conveyor" } },
  { food: true, year: 2020, client: "AB Food & Beverages", name: { th: "ระบบรวมไลน์สายพาน (Merge conveyor)", en: "Merge conveyor system" } },
  { food: true, year: 2020, client: { th: "เบอร์รี่ ยุคเกอร์ ฟู้ดส์", en: "Berli Jucker Foods" }, name: { th: "ระบบนับและแยกสินค้าขาออกด้วยบาร์โค้ด", en: "Outbound barcode counting & sorting" } },
  { food: true, year: 2020, client: { th: "เบอร์รี่ ยุคเกอร์ ฟู้ดส์", en: "Berli Jucker Foods" }, name: { th: "สายพานเรียงขนมตามจังหวะเครื่องแพ็ค", en: "Snack timing conveyor to the packer" } },
  { food: true, year: 2019, client: { th: "ซีพีแรม", en: "CP RAM" }, name: { th: "ระบบเติมน้ำมันอัตโนมัติ", en: "Automatic oil filling" } },
  { food: false, year: 2021, client: "UBE Chemicals Asia", name: { th: "หุ่นยนต์ติดสติกเกอร์บาร์โค้ดอัตโนมัติ", en: "Robotic barcode labelling" } },
  { food: false, year: 2020, client: { th: "นิกโก คอร์ปอเรชั่น", en: "Nikko Corporation" }, name: { th: "เครื่องประกอบแตรรถยนต์และรถจักรยานยนต์", en: "Car & motorcycle horn assembly machine" } },
  { food: false, year: 2019, client: "Thai Optical Group", name: { th: "Sorter 30 ช่อง อัตโนมัติเต็มรูปแบบ", en: "30-gate fully automatic sorter" } },
];

export const credits = [
  ["vibratory-feeder", "\"Bowl Feeder\" by Richdsu, public domain"],
  ["packaging-line", "\"SSF Costco bakery pastry packaging line\" by BrokenSphere, CC BY-SA 3.0"],
  ["agv", "\"AGV - Automated Guided Vehicle\" by Marta Veverica, CC BY-SA 4.0"],
  ["palletizer", "\"Factory Automation Robotics Palettizing Bread\" by KUKA Roboter GmbH, public domain"],
  ["load-cell", "\"Load Cell fitted under tank leg\" by GRALISTAIR, CC BY-SA 4.0"],
  ["scada", "\"NEWater S.C.A.D.A. room\" by Z22, CC BY-SA 4.0"],
  ["laser-marker", "\"Laser Engraving Machine\" by Jason7825, public domain"],
];
